module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackSemiExtIt.4f3c05d.woff";